import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { organizationDetailsKeys } from '../../api/query-keys/organization-details';

import { organizationApi } from '@/api/organization-admin/organization';

export const useUpdateOrganizationLogo = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['settings']);

  return useMutation({
    mutationFn: (logoFile: File) => organizationApi.updateOrganizationLogo(logoFile),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: organizationDetailsKeys.all,
      });
      onSuccess?.();
      toast.success(t('settings:logo.addSuccess'));
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
